import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Compass, Activity, Users, TrendingUp } from 'lucide-react';
import '../../styles/components/landing/MethodologySection.css';

const STEPS = [
  { icon: <Eye size={22} />,        title: 'Consciência',     description: 'Mapeie gatilhos, padrões e impacto real na sua vida.' },
  { icon: <Compass size={22} />,    title: 'Planejamento',    description: 'Um plano sob medida do dia 1 ao dia 365.' },
  { icon: <Activity size={22} />,   title: 'Acompanhamento', description: 'Métricas, check-ins diários e protocolos de emergência.' },
  { icon: <Users size={22} />,      title: 'Comunidade',      description: 'Pares, mentores e grupos anônimos disponíveis 24/7.' },
  { icon: <TrendingUp size={22} />, title: 'Evolução',        description: 'Conquistas, marcos e reconstrução de identidade.' },
];

const MethodologySection = ({ eyebrow, title, subtitle, steps = STEPS }) => {
  return (
    <section id="methodology" className="ls-method">
      <div className="container">
        <div className="ls-method__header">
          {eyebrow && <span className="ls-method__eyebrow">{eyebrow}</span>}
          <h2 className="ls-method__title">{title}</h2>
          {subtitle && <p className="ls-method__subtitle">{subtitle}</p>}
        </div>

        <div className="ls-method__timeline">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              className="ls-method__step"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              <div className="ls-method__step-index">{String(i + 1).padStart(2, '0')}</div>
              <div className="ls-method__step-icon">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MethodologySection;
